import { Grid } from '@mui/material'
import { FieldValues } from 'react-hook-form'

import Button from 'components/Button'
import Checkbox from 'components/ReactHookFom/checkbox'
import Form from 'components/ReactHookFom/form'
import Input from 'components/ReactHookFom/input'
import { useCreatePartners, useUpdatePartner } from 'hooks/MasterTables'
import { PageInterface } from 'utils/apiInterfaces'
import {
  LabelStyle,
  StyledFormBottom,
  StyledGridColumn,
} from 'utils/constants/styledComponent'

import { buttonTitles } from '../utils/constants'
import { IPartner } from '../utils/interface'

interface ICreatePlatform {
  row?: IPartner
  closeModel: () => void
  fetchPartners: ({ page, rowsPerPage }: PageInterface) => Promise<void>
  pageController: { pageIndex: number; pageSize: number }
}

const Create = ({
  row,
  closeModel,
  fetchPartners,
  pageController,
}: ICreatePlatform) => {
  const createPartners = useCreatePartners()
  const updatePartner = useUpdatePartner()

  const handleFormSubmit = async (data: FieldValues) => {
    if (row?.name) {
      // Update existing partner
      await updatePartner(row?.id?.toString(), {
        name: data.name,
        isActive: data.isActive,
      })
    } else {
      // Create new partner
      await createPartners({ name: data.name, isActive: data.isActive })
    }

    // Refresh the partner list and close the modal
    await fetchPartners({
      page: pageController.pageIndex + 1,
      rowsPerPage: pageController.pageSize,
    })
    closeModel()
  }

  return (
    <Form
      onSubmit={(data: FieldValues) => handleFormSubmit(data)}
      defaultValues={{
        name: row?.name || '',
        isActive: row?.isActive ?? true,
      }}
    >
      <Grid container>
        <StyledGridColumn container>
          <Grid item xs={3}>
            <LabelStyle>Name</LabelStyle>
          </Grid>
          <Grid item xs={9}>
            <Input name="name" id="name" rules={{ required: true }} />
          </Grid>
        </StyledGridColumn>

        <StyledGridColumn container>
          <Grid item xs={3}>
            <LabelStyle>Active</LabelStyle>
          </Grid>
          <Grid item xs={9}>
            <Checkbox name="isActive" />
          </Grid>
        </StyledGridColumn>

        <StyledFormBottom container gap={2}>
          <Grid item>
            <Button label="Cancel" variant="outlined" onClick={closeModel} />
          </Grid>
          <Grid item>
            <Button
              label={row?.name ? buttonTitles.UPDATE : buttonTitles.CREATE}
              variant="contained"
              type="submit"
            />
          </Grid>
        </StyledFormBottom>
      </Grid>
    </Form>
  )
}

export default Create
